import { ValidationErrorMessages } from '@constants/forms';

import { TariffFormValues } from './types';

const validateForm = (values: TariffFormValues) => {
  const errors: Partial<Record<keyof TariffFormValues, string>> = {};

  if (!values.tariffType) {
    errors.tariffType = ValidationErrorMessages.FIELD_REQUIRED;
  }

  return errors;
};

export { validateForm };
